import React, {useEffect} from "react";
import {UnityApp} from "../components/UnityApp";
import ReactGA from "react-ga";

export const HomepageView = () => {
    useEffect(() => {
        ReactGA.set({page: "/con/homepage"});
        ReactGA.pageview("/con/homepage");
    }, []);
    return (
        <div className="AppViews--view">
            <UnityApp path="/application/wrapper.html"/>
        </div>
    );
};
